import React from 'react'

import { ReactComponent as BoardIcon } from './../../assets/theme-icons/board.svg'
import { ReactComponent as NumbersIcon } from './../../assets/theme-icons/numbers.svg'
import { ReactComponent as ShareholderIcon } from './../../assets/theme-icons/shareholder.svg'
import { ReactComponent as TopicsIcon } from './../../assets/theme-icons/topics.svg'

const themeIcons = {
  'Shareholder voting participation': <ShareholderIcon></ShareholderIcon>,
  'By the numbers': <NumbersIcon></NumbersIcon>,
  'Hot topics': <TopicsIcon></TopicsIcon>,
  'Get on board': <BoardIcon></BoardIcon>,
}

const ThemeIcon = ({ theme }) => {
  return themeIcons[theme]
}

export default ThemeIcon
